import { shortDate, shortDay } from '@utils/i18n';

interface JobDateProps {
  date: Date;
}

export const JobDate = ({ date }: JobDateProps) => (
  <div className="col-start-1 col-end-5 flex h-7 items-center gap-2 bg-neutral-200 px-6 py-1">
    <span className="font-bold text-neutral-800">
      {[shortDay(date), shortDate(date)].join(', ')}
    </span>
  </div>
);
